<template>
	<card>
		<div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <h5 class="back-title" @click="back()"><i class="fa fa-angle-left"></i> Back To Admin </h5>
				</div>
				<div class="col-sm-6 offset-sm-3 col-xs-12">
					<h4 class="header-title pr-5">Circuits</h4>
					<div class="row" v-for="channel in data">
						<div class="col-xl-1">
							<label class="site-name">{{ channel.device_order }}</label>
						</div>
						<div class="col-xl-5">
							<label class="site-name">{{ channel.device_name }}</label>
						</div>
						<div class="col-xl-3">
							<div id="danger-bar" v-if="channel.status == 'danger'" style="cursor: pointer;"></div>
							<div id="amber-bar" v-else-if="channel.status == 'amber'" style="cursor: pointer;"></div>
							<div id="normal-bar" v-else style="cursor: pointer;"></div>
						</div>
					</div>
				</div>
			</div>
        </div>
	</card>
</template>
<script>
import Card from "./Card.vue";
import { mapActions, mapGetters } from "vuex";
import QuerySetting from '@/mixins/querySetting';
import OctoberData from '@/mixins/octoberData';

export default {
	name: "channel-status-card",
	mixins: [QuerySetting, OctoberData],
	components: {
		Card
	},
	props: {
		title: {
			type: String,
			default: ""
		}
	},
	data() {
		return {
			isLoading: true,
			data: [],
			siteName: ''
		};
	},
	computed: {
		...mapGetters({
			periodTime: 'settime/getPeriodTime',
			currentDayPower			: 'influx/getCurrentDayPower',
			currentNightPower		: 'influx/getCurrentNightPower',
			user: 'auth/getUser',
			defaultSiteId: 'auth/getDefaultSiteId',
			defaultSiteName: 'auth/defaultSiteName'
		})
	},
    async created() {
		const channelStatusData = await this.getChannelStatus(this.$route.params.id);
		this.siteName = this.$route.params.name;
        this.data = channelStatusData;
		this.isLoading = false;
	},
	methods: {
		...mapActions({
			getChannelStatus: "admin/getChannelStatus",
		}),

        back() {
            this.$router.push({name: 'status'});
        }
	},
};
</script>
<style lang="scss" scoped>

.site-name {
	color: white;
	font-family: "Nunito Sans Light";
	font-weight: 100;
}

#amber-bar {
	width: 100%;
    height: 25px;
    background-color: #FFBF00;
    padding: 5px 15px;
}

#normal-bar {
    width: 100%;
    height: 25px;
    background-color: green;
    padding: 0 15px;
}

#danger-bar {
    width: 100%;
    height: 25px;
    background-color: red;
    padding: 0 15px;
}
.total-value {
	position: absolute;
	top: 40%;
	left: 110px;
	text-align: center;

	span {
		font-size: 22px;
		font-family: 'Nunito Sans Regular';
		font-weight: 600;
		line-height: 1.1;
	}
}
</style>
